// extracted by mini-css-extract-plugin
export var copyableField = "_pw-4";
export var customerBadge = "_pw-0";
export var customerInfoTitle = "_pw-2";
export var details = "_pw-1";
export var dropdownContainer = "_pw-5";
export var dropdownImage = "_pw-6";
export var editAssigneeForm = "_pw-a";
export var editButton = "_pw-3";
export var email = "_pw-7";
export var hidden = "_pw-d";
export var input = "_pw-8";
export var saveButton = "_pw-b";
export var shopifyIcon = "_pw-c";
export var suggestionBadge = "_pw-e";
export var suggestionText = "_pw-f";
export var username = "_pw-9";